export enum Organization {
  OPEN_ENGLISH = 'OPEN_ENGLISH',
  NEXTU = 'NEXTU',
}
